import { render } from "./BlFormFieldEmail.vue?vue&type=template&id=ef45d172"
import script from "./BlFormFieldEmail.vue?vue&type=script&lang=js"
export * from "./BlFormFieldEmail.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/f3315f41-3418-4066-838e-b0c15008937b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__